import proj4 from "proj4";

// `.inp` has no CRS field — there is no way to tell a real-world projected
// model from an arbitrary local drawing plane from the file alone, so
// georeferencing is always an explicit user choice, never inferred from the
// coordinate values themselves.

export const WGS84_PROJ4 = "+proj=longlat +datum=WGS84 +no_defs";

export interface AreaOfUse {
  north: number;
  south: number;
  east: number;
  west: number;
}

export interface CrsChoice {
  /** null means "not georeferenced" — plane mode. */
  proj4: string | null;
  label: string;
  areaOfUse?: AreaOfUse;
}

export const PLANE: CrsChoice = { proj4: null, label: "Plane (not georeferenced)" };

/** Uses proj4's own internal `projName === "longlat"` test rather than a `+proj=longlat`-only regex, so this also works for a CRS defined as raw WKT text. The try/catch is defensive: a malformed definition must read as "not geographic" here, not throw and break the map's own corner readout. */
export function isGeographicCrs(proj4Str: string): boolean {
  try {
    // proj4's TS types don't declare `projName`, even though the runtime
    // instance always has it.
    const parsed = proj4.Proj(proj4Str) as unknown as { projName?: string };
    return parsed.projName === "longlat";
  } catch {
    return false;
  }
}
